import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const LabelPrintingListService = {
  async printLabel(payload) {
    var url = "api/LabelPrinting";
    await ApiService.post(url, payload);
  },
  async holdOrders(payload) {
    var url = "api/SalesOrder/HoldOrders";
    await ApiService.post(url, payload);
  },
  async activateOrders(payload) {
    var url = "api/SalesOrder/ActivateOrders";
    await ApiService.post(url, payload);
  },
};

export { LabelPrintingListService };
